// API base URL:
//  - dev (`npm start`)  -> local backend on :8000
//  - production build   -> deployed Render backend
//  - override anytime via REACT_APP_API_BASE_URL
const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:8000"
    : "https://stock-visual.onrender.com");

export default BASE_URL;
